/**
 * @function
 * @name types
 * @description Creates an object with type information about the given parameter.
 * @param {*} param - The parameter to analyze.
 * @returns {TypeInformation} An object containing type information properties.
 * @memberof utils
 * @example
 * const paramInfo = types("example");
 * console.log(paramInfo.isString); // true
 */
export function types(param) {
  /**
   * @typedef {Object} TypeInformation
   * @property {boolean} isDefined - Indicates whether the parameter is defined (not undefined).
   * @property {boolean} isBoolean - Indicates whether the parameter is a boolean.
   * @property {boolean} isString - Indicates whether the parameter is a string.
   * @property {boolean} isObject - Indicates whether the parameter is a non-array object and not null.
   * @property {boolean} isNull - Indicates whether the parameter is null.
   * @property {boolean} isNumber - Indicates whether the parameter is a number.
   * @property {boolean} isFunction - Indicates whether the parameter is a function.
   * @property {boolean} isArray - Indicates whether the parameter is an array.
   */

  const type = typeof param;
  const isArray = Array.isArray(param);
  const isNull = param === null;

  /**
   * @type {TypeInformation}
   */
  const typeInfo = {
    isDefined: type !== "undefined",
    isBoolean: type === "boolean",
    isString: type === "string",
    isObject: type === "object" && !isArray && !isNull,
    isNull,
    isNumber: type === "number",
    isFunction: type === "function",
    isArray,
  };

  return typeInfo;
}
